import React from "react";

const ErrorDisplay = ({ errors }) => {
  if (!errors) return null;

  // Handle object with error field (from API response)
  if (typeof errors === "object" && errors.error) {
    try {
      // Try to parse the error string which contains JSON objects
      const errorString = errors.error;
      const errorMatches = errorString.match(/\{[^}]+\}/g);

      if (errorMatches && errorMatches.length > 0) {
        const parsedErrors = errorMatches.map(err => {
          try {
            return JSON.parse(err);
          } catch {
            return null;
          }
        }).filter(Boolean);

        return (
          <div style={{
            marginTop: "15px",
            padding: "20px",
            backgroundColor: "#fff8e1",
            border: "1px solid #ffb300",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
          }}>
            <div style={{
              fontWeight: "bold",
              marginBottom: "15px",
              color: "#e65100",
              fontSize: "16px",
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}>
              <span style={{ fontSize: "20px" }}>⚠️</span>
              <span>Validation Errors Found ({parsedErrors.length})</span>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              {parsedErrors.map((error, index) => (
                <div key={index} style={{
                  padding: "15px",
                  backgroundColor: "white",
                  borderRadius: "6px",
                  borderLeft: "4px solid #ff9800",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.08)"
                }}>
                  <div style={{
                    display: "grid",
                    gridTemplateColumns: "120px 1fr",
                    gap: "8px",
                    fontSize: "14px"
                  }}>
                    <div style={{ fontWeight: "600", color: "#555" }}>Sheet:</div>
                    <div style={{ color: "#333" }}>{error.sheet}</div>

                    <div style={{ fontWeight: "600", color: "#555" }}>Location:</div>
                    <div style={{ color: "#333" }}>
                      <span style={{
                        backgroundColor: "#e3f2fd",
                        padding: "2px 8px",
                        borderRadius: "4px",
                        fontFamily: "monospace",
                        fontSize: "13px"
                      }}>
                        Row {error.row}, Column {error.column}
                      </span>
                    </div>

                    <div style={{ fontWeight: "600", color: "#555" }}>Error:</div>
                    <div style={{ color: "#d32f2f", fontWeight: "500" }}>{error.msg}</div>

                    {error.type && (
                      <>
                        <div style={{ fontWeight: "600", color: "#555" }}>Type:</div>
                        <div style={{
                          color: "#666",
                          fontSize: "12px",
                          fontStyle: "italic"
                        }}>
                          {error.type}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {errors.note && (
              <div style={{
                marginTop: "15px",
                padding: "12px",
                backgroundColor: "#e1f5fe",
                borderRadius: "6px",
                fontSize: "13px",
                color: "#01579b",
                display: "flex",
                alignItems: "center",
                gap: "8px"
              }}>
                <span style={{ fontSize: "16px" }}>📌</span>
                <span style={{ fontWeight: "500" }}>{errors.note}</span>
              </div>
            )}
          </div>
        );
      }
    } catch (e) {
      console.error("Error parsing errors:", e);
    }

    // Fallback for object errors
    const message = `${errors["message"] ?? 'An error occurred'} ${errors['table'] ? `in table: "${errors['table']}"` : ''}`;
    return (
      <div style={{
        marginTop: "15px",
        padding: "12px",
        backgroundColor: "#ffebee",
        color: "#c62828",
        borderRadius: "6px",
        border: "1px solid #ef5350"
      }}>
        {message}
      </div>
    );
  }

  // Handle string errors
  if (typeof errors === "string") {
    return (
      <div style={{
        marginTop: "15px",
        padding: "12px",
        backgroundColor: "#ffebee",
        color: "#c62828",
        borderRadius: "6px",
        border: "1px solid #ef5350"
      }}>
        {errors}
      </div>
    );
  }

  // Handle array of errors
  if (Array.isArray(errors)) {
    return (
      <div style={{
        marginTop: "15px",
        display: "flex",
        flexDirection: "column",
        gap: "8px"
      }}>
        {errors.map((error, index) => (
          <div key={error.msg || index} style={{
            padding: "10px",
            backgroundColor: "#ffebee",
            color: "#c62828",
            borderRadius: "6px",
            border: "1px solid #ef5350"
          }}>
            {error.msg}
          </div>
        ))}
      </div>
    );
  }

  return null;
};

export default ErrorDisplay;
